export enum MutationQuery {
	UPSERT_ORDER_INFO = `
    mutation UpsertOrderInfo($upsertOrderInfoInput: UpsertOrderInfoInput) {
        upsertOrderInfo(
            upsertOrderInfoInput: $upsertOrderInfoInput
        ) {
            success
            message
        }
    }
    `,

	UPSERT_ORDER_DETAILS = `
    mutation UpsertOrderDetails($upsertOrderDetailsInput: UpsertOrderDetailsInput) {
        upsertOrderDetails(
            upsertOrderDetailsInput: $upsertOrderDetailsInput
        ) {
            success
            message
        }
    }
    `,

	UPDATE_ORDER_STATUS = `
    mutation UpdateOrderStatus($updateOrderStatusInput: UpdateOrderStatusInput) {
        updateOrderStatus(updateOrderStatusInput: $updateOrderStatusInput) {
            success
            message
        }
    }
    `,

	DELETE_ORDER = `
    mutation DeleteOrder($deleteOrderInput: DeleteOrderInput) {
        deleteOrder(deleteOrderInput: $deleteOrderInput) {
            success
            message
        }
    }
    `,

	CREATE_TEMPLATE = `
    mutation CreateTemplate($createTemplateInput: CreateTemplateInput) {
        createTemplate(
            createTemplateInput: $createTemplateInput
        ) {
            success
            message
        }
    }
    `,
	DELETE_TEMPLATE = `
    mutation DeleteTemplate($deleteTemplateInput: DeleteTemplateInput) {
        deleteTemplate( deleteTemplateInput: $deleteTemplateInput) {
            success
            message
        }
    }
    `,

	UPDATE_SHOT_STATUS = `
        mutation UpdateShotStatus($updateShotStatusInput: UpdateShotStatusInput) {
            updateShotStatus( updateShotStatusInput: $updateShotStatusInput) {
                success
                message
            }
        }
    `,

	DELETE_SHOT_IMAGE = `
    mutation DeleteShotImage($deleteShotImageInput: DeleteShotImageInput) {
        deleteShotImage( deleteShotImageInput: $deleteShotImageInput) {
            success
            message
        }   
    }
    `,
	SET_DEFAULT_COLOR = `
    mutation SetDefaultColor($setDefaultColorInput: SetDefaultColorInput) {
        setDefaultColor( setDefaultColorInput: $setDefaultColorInput) {
            success
            message
        }
    }
    `,

	ADD_PRODUCTS_TO_ORDER = `
    mutation AddProductsToOrder($addproductToOrderInput: AddProductsToOrderInput) {
        addProductsToOrder(
            addproductToOrderInput: $addproductToOrderInput
        ) {
            success
            message
        }
    } `,

	REMOVE_PRODUCTS_FROM_ORDER = `
    mutation RemoveProductsFromOrder($removeProductsFromOrderInput: RemoveProductsFromOrderInput) {
        removeProductsFromOrder(
            removeProductsFromOrderInput: $removeProductsFromOrderInput
        ) {
            success
            message
        }
    }`,

	REMOVE_COLORS_FROM_PRODUCT = `
    mutation RemoveColorsFromProduct($removeColorsFromProductInput: RemoveColorsFromProductInput) {
        removeColorsFromProduct(
            removeColorsFromProductInput: $removeColorsFromProductInput
        ) {
            success
            message
        }
    }`,

	UPSERT_SHOT_COST_TEMPLATE = `
    mutation UpsertCostTemplate($upsertCostTemplateInput: UpsertCostTemplateInput) {
        upsertCostTemplate(upsertCostTemplateInput: $upsertCostTemplateInput) {
            success
            message
        }
    }
    `,

	DELETE_SHOT_COST_TEMPLATE = `
    mutation DeleteCostTemplate($deleteCostTemplateInput: DeleteCostTemplateInput) {
        deleteCostTemplate(deleteCostTemplateInput: $deleteCostTemplateInput) {
            success
            message
        }
    }
    `,


    UPDATE_ORDER_SIZE_QUANTITY = `
    mutation UpdateOrderSizeQuantity($updateOrderSizeQuantityInput: UpdateOrderSizeQuantityInput) {
        updateOrderSizeQuantity(
            updateOrderSizeQuantityInput: $updateOrderSizeQuantityInput
        ) {
            success
            message
        }
    }`,

	UPSERT_PHOTOGRAPHER = `
    mutation UpsertPhotographer($upsertPhotographerInput: UpsertPhotographerInput) {
        upsertPhotographer(upsertPhotographerInput: $upsertPhotographerInput) {
            success
            message
        }
    }
    `,

	DELETE_PHOTOGRAPHER = `
    mutation DeletePhotographer($deletePhotographerInput: DeletePhotographerInput) {
        deletePhotographer(deletePhotographerInput: $deletePhotographerInput) {
            success
            message
        }
    }
    `,

    SET_AI_GENERATED = `
    mutation setIsAi($setIsAiInput: SetIsAiInput) {
        setIsAi(setIsAiInput: $setIsAiInput) {
            success
            message
        }
    }
    `,

    UPDATE_ORDER_COST = `
    mutation UpdateOrderCost($orderId: Int!) {
        updateOrderCost(updateOrderCostInput: { orderId: $orderId }) {
            success
            message
        }
    }
    `,

	SET_FINAL_COST = `
	mutation SetFinalCost($setFinalCostInput: SetFinalCostInput) {
		setFinalCost(setFinalCostInput: $setFinalCostInput) {
			success
			message
		}
	}
    `,

    ADD_USER_PROFILE_ROLE = `
	mutation AddRoleToUserProfile($addRoleToUserInput: AddRoleToUserProfileInput) {
		addRoleToUserProfile(addRoleToUserInput: $addRoleToUserInput) {
			success
			message
		}
	}
    `,

    UPDATE_USER_PROFILE_ROLE = `
	mutation UpdateRoleToUserProfile($updateRoleToUserInput: UpdateRoleToUserProfileInput) {
		updateRoleToUserProfile(updateRoleToUserInput: $updateRoleToUserInput) {
			success
			message
		}
	}
    `,

    DELETE_USER_PROFILE_ROLE = `
	mutation DeleteUserProfileRole($deleteUserProfileRoleInput: DeleteUserProfileRoleInput) {
		deleteUserProfileRole(deleteUserProfileRoleInput: $deleteUserProfileRoleInput) {
			success
			message
		}
	}
    `,

    MARK_NOTIFICATION_AS_READ = `
    mutation MarkNotificationAsRead($markNotificationAsReadInput: MarkNotificationAsReadInput) {
        markNotificationAsRead(markNotificationAsReadInput: $markNotificationAsReadInput) {
            success
            message
        }
    }
    `,
}
